import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative h-screen">
      {/* YouTube Video Background */}
      <div className="absolute inset-0 overflow-hidden">
        <iframe
          src="https://www.youtube.com/embed/rMtte4inipk?autoplay=1&mute=1&loop=1&playlist=rMtte4inipk&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] h-[56.25vw] min-h-full min-w-full -translate-x-1/2 -translate-y-1/2"
          allow="autoplay; encrypted-media"
          title="Background Video"
          style={{ border: 'none', pointerEvents: 'none' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/45d0854881d907e8cddfcd7aa22fcf03.png"
                alt="Fun Time Photobooths"
                className="h-16 w-auto"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-900 hover:text-orange-500' : 'text-gray-900 hover:text-orange-500'
                }`}
              >
                Home
              </Link>
              <Link
                to="/overhead-360"
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-900 hover:text-orange-500' : 'text-gray-900 hover:text-orange-500'
                }`}
              >
                Overhead 360
              </Link>
              <Link
                to="/photo-booth"
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-900 hover:text-orange-500' : 'text-gray-900 hover:text-orange-500'
                }`}
              >
                Photo Booth
              </Link>
              <Link
                to="/contact"
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-900 hover:text-orange-500' : 'text-gray-900 hover:text-orange-500'
                }`}
              >
                Contact Us
              </Link>
              <Link
                to="/about"
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-900 hover:text-orange-500' : 'text-gray-900 hover:text-orange-500'
                }`}
              >
                About
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight" style={{ textShadow: '0 0 20px rgba(249, 115, 22, 0.8), 0 0 40px rgba(249, 115, 22, 0.5), 0 0 60px rgba(249, 115, 22, 0.3)' }}>
            San Diego's Premier Overhead 360 & Luxury Photo Booth Experiences
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto">
            Show-stopping photo & video booths for weddings, corporate events, and celebrations that deserve more than ordinary.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-4 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Your Event
            </Link>
            <Link
              to="/overhead-360"
              className="px-8 py-4 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              View Our Booths
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
